import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { ContextPanelEl } from "common/widgets/context-panel";
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { ButtonEl } from "common/components/button";
import { ConfirmEl } from "common/components/confirm";
import { CreateEntityModalEl } from "common/widgets/create-entity-modal";
import { ButtonTheme } from "common/components/button/constants";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { RowLabelType } from "common/query-builder/query-entry-section/types";
import { Directions } from "common/components/drop-menu/types";
import { CustomPropertyResourceType } from "common/report/stores/custom-properties";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { MarkdownEl } from "common/components/markdown";
import { EditorEl } from "./editor";
const UPSELL_TEXT = `When you upgrade your plan, custom properties can be created and saved to use across all reports in a project.`;
const FieldErrorTooltip = ({ errors, field }) => {
  if (errors[field]) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".custom-property-error-tooltip"
    }, /* @__PURE__ */ jsx(MarkdownEl, {
      sel: ".mp-tooltip-text",
      attrs: { text: errors[field] }
    }));
  }
  return null;
};
function renderUpsellButton({
  component,
  text,
  theme
}) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".upsell-button"
  }, /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Top, size: DisplaySize.Medium }
  }, UPSELL_TEXT), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme,
      icon: `share`
    },
    on: { click: component.helpers.openPricingUpsell }
  }, text));
}
export function template() {
  const {
    autocompleteOpen,
    autocompletePopup,
    currentAutocompleteLine,
    customProperty,
    errors,
    toCreate,
    toDelete,
    tooltipData
  } = this.state;
  const bannerText = this.getBannerText();
  return /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-modal-wrapper"
  }, !toCreate ? /* @__PURE__ */ jsx(ModalEl, {
    sel: ".custom-property-modal",
    attrs: {
      open: this.attr(`open`),
      "grow-to-content": true
    },
    on: {
      change: this.helpers.modalStateChange
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-card-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-card-header-title"
  }, this.helpers.getHeaderText())), /* @__PURE__ */ jsx("form", {
    sel: ".custom-property-body",
    class: { "for-behaviors": this.helpers.isBehavioralProperty() }
  }, bannerText && /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section"
  }, /* @__PURE__ */ jsx(BannerEl, {
    attrs: {
      theme: BannerTheme.Info,
      "body-text": bannerText,
      type: BannerType.Embedded
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Name"), /* @__PURE__ */ jsx(FieldErrorTooltip, {
    errors,
    field: "name"
  })), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-container"
  }, /* @__PURE__ */ jsx("input", {
    sel: ".custom-property-section-input",
    on: {
      input: (ev) => this.helpers.updateName(ev.target.value)
    },
    attrs: {
      autocomplete: `off`,
      elref: `nameInput`
    },
    props: {
      size: 50,
      type: `text`,
      value: this.helpers.getName()
    },
    class: {
      "custom-property-error": !!errors.name
    }
  }))), this.helpers.isPersisted() ? /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Description", /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-description-tooltip"
  }, "Optional"))), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-container"
  }, /* @__PURE__ */ jsx("input", {
    sel: ".custom-property-section-input",
    on: {
      input: this.helpers.updateDescription
    },
    props: {
      size: 50,
      type: `text`,
      value: this.helpers.getDescription()
    }
  }))) : null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-builder"
  }, this.helpers.isBehavioralProperty() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-section-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label"
  }, "Define condition")), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-query-events-section"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    entries: this.helpers.getQueryEntries(),
    enableWorkspaceFilterRestrictions: this.attr(`enable-workspace-filter-restrictions`),
    hideEditControls: true,
    includeCustomProperties: "persisted-only",
    disableDeleteEntry: true,
    projectId: this.attr(`project-id`),
    rowLabelType: RowLabelType.None,
    metricsMode: true,
    rowLimit: 1,
    rowTypes: this.helpers.getBehavioralSelectorTypes(),
    eventAggregatorFunctions: this.helpers.getBehavioralAggregationMethods(),
    propertyAggregatorFunctions: this.helpers.getBehavioralAggregationMethods(),
    trackName: this.attr(`track-name`),
    userId: this.attr(`user-id`),
    workspaceId: this.attr(`workspace-id`),
    onUpdate: this.helpers.handleQueryEventsSectionUpdate
  }))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-flex-wrapper.custom-property-formula-flex-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-label.custom-property-formula-label"
  }, "Formula"), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-tooltip",
    on: { click: this.helpers.tooltipClicked }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": `480px`, placement: Placement.Right, clickable: `true` }
  }, "Click to view documentation")), /* @__PURE__ */ jsx(FieldErrorTooltip, {
    errors,
    field: "displayFormula"
  })), /* @__PURE__ */ jsx(SelectEl, {
    sel: ".custom-property-example-menu",
    attrs: {
      elref: `insertExample`,
      "menu-width": 160,
      options: this.helpers.getExampleOptions(),
      "selected-option": `Insert Example`,
      "disable-search": true
    },
    on: {
      change: this.helpers.handleInsertExample
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-input-area",
    class: {
      "custom-property-error": !!errors.displayFormula
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-ace-wrapper",
    key: "ace-editor"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-border"
  }), this.isEditorReady() && /* @__PURE__ */ jsx(EditorEl, {
    attrs: {
      "all-data-groups": this.attr(`all-data-groups`),
      "composed-properties": JSON.stringify(this.helpers.getComposedProperties()),
      "data-group-id": this.attr(`data-group-id`),
      "display-formula": this.helpers.getDisplayFormula(),
      "event-names": this.attr(`event-names`),
      "enable-workspace-filter-restrictions": this.attr(`enable-workspace-filter-restrictions`),
      "hide-user-props": this.attr(`hide-user-props`),
      "show-all-data-groups": this.attr(`show-all-data-groups`),
      "show-borrowed-properties": this.attr(`show-borrowed-properties`),
      "project-id": this.attr(`project-id`),
      "resource-type": this.helpers.getResourceType(),
      "user-id": this.attr(`user-id`),
      "workspace-id": this.attr(`workspace-id`),
      "show-borrow-property-action": this.canUseBorrowedProperties() && this.helpers.getResourceType() === CustomPropertyResourceType.Events,
      elref: `ace-editor`
    },
    on: {
      connect: this.helpers.handleEditorConnect,
      change: this.helpers.handleValueChange,
      autocompleteChange: this.helpers.handleEditorAutocompleteChange
    },
    hook: {
      insert: this.helpers.handleEditorElementInsert
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-border"
  })), autocompletePopup ? /* @__PURE__ */ jsx(ContextPanelEl, {
    attrs: {
      placement: autocompleteOpen ? Directions.Right : Directions.Left,
      "force-placement": !autocompleteOpen,
      "always-expanded": true
    },
    params: {
      data: tooltipData,
      positionParent: autocompleteOpen ? autocompletePopup : currentAutocompleteLine
    }
  }) : null), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-info-tooltip"
  }, "Press", /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: { text: `Period (.)`, theme: TEXT_HIGHLIGHT_THEME.GENERIC, size: `medium` }
  }), "to insert a property and", /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: { text: `Control + Space`, theme: TEXT_HIGHLIGHT_THEME.GENERIC, size: `medium` }
  }), "to see a list of formula functions.")))), /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-footer"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-flex-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-property-action-wrapper"
  }, (() => {
    if (this.helpers.isPersisted()) {
      return /* @__PURE__ */ jsx(ButtonEl, {
        on: { click: this.helpers.setToDelete }
      }, "Delete");
    } else if (!this.helpers.isBehavioralProperty() && !this.usesBorrowedProperty()) {
      if (this.helpers.isSavingRestricted()) {
        return renderUpsellButton({
          component: this,
          text: `Upgrade to Save`,
          theme: ButtonTheme.Secondary
        });
      } else if (!this.attr(`enable-workspace-filter-restrictions`)) {
        return /* @__PURE__ */ jsx(ButtonEl, {
          attrs: {
            disabled: this.helpers.isSavingDisabled()
          },
          on: { click: () => this.helpers.applyProperty(true) }
        }, "Save");
      } else {
        return null;
      }
    } else {
      return null;
    }
  })())), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-cancel-button",
    attrs: { theme: ButtonTheme.Tertiary },
    on: { click: this.helpers.closeModal }
  }, "Cancel"), this.helpers.isEdit() && this.helpers.isPersisted() ? this.helpers.isSavingRestricted() ? renderUpsellButton({ component: this, text: `Upgrade to Update`, theme: ButtonTheme.Primary }) : /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-save-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: this.helpers.isSavingDisabled()
    },
    on: { click: () => this.helpers.applyProperty(false) }
  }, "Update") : this.usesBorrowedProperty() && this.helpers.isSavingRestricted() ? renderUpsellButton({ component: this, text: `Upgrade to Save`, theme: ButtonTheme.Primary }) : /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".custom-property-button.custom-property-save-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: this.helpers.isSavingDisabled(),
      elref: `applyButton`
    },
    on: { click: () => this.helpers.applyProperty(this.usesBorrowedProperty()) }
  }, this.usesBorrowedProperty() ? `Save` : `Apply`)), /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: { theme: THEME.DELETE, open: !!toDelete, closeable: true },
    on: {
      change: (ev) => this.helpers.handleDeleteConfirmChange(ev.detail.state),
      submit: (ev) => {
        if (ev.detail.action === `confirm`) {
          this.helpers.deleteProperty();
        }
      }
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, "Delete Custom Property"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description"
  }, 'Are you sure you want to delete "', customProperty.name, '"? This action is permanent and cannot be undone.')))) : /* @__PURE__ */ jsx(CreateEntityModalEl, {
    attrs: this.helpers.buildCreateEntityModalAttrs(),
    on: {
      nameInput: (ev) => this.helpers.updateName(ev.detail.name),
      save: this.helpers.handleCreate,
      cancel: this.helpers.handleCancelCreate,
      saveAndShare: this.helpers.handleCreate
    },
    props: {
      existingEntityNames: this.helpers.getPersistedCustomPropertyNames()
    }
  }));
}
